module.exports = __webpack_public_path__ + "static/media/icono.50562dc9.png";